"use client";

import { UiSheet, UiSheetTitle } from "@frontend/roz-uikit";

import { cn } from "@/lib/cn";
import { useSdk } from "@/provider";
import { useSheetStore } from "@/ui-state";
import { Menu } from "../components/menu";
import { RegionSelect } from "../components/region-select";
import {
  classNameByType,
  closeButtonByType,
  sideByType,
} from "./sheet-helpers";

export const Sheet = () => {
  const { close, isOpen, open, type } = useSheetStore();
  const sdk = useSdk();
  const isMenuType = type === "menu";

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      sdk.events.emit("closeSheet");
      close();
      return;
    }

    open();
  };

  const renderContent = () => {
    switch (type) {
      case "menu": {
        return (
          <>
            <UiSheetTitle className="sdkui:sr-only">
              Проекты РОЗ, Календарь мероприятий, Лекторы РОЗ и многое другое!
            </UiSheetTitle>
            <Menu />
          </>
        );
      }
      case "region-select": {
        return (
          <>
            <UiSheetTitle className="sdkui:sr-only">
              Укажите ваш регион
            </UiSheetTitle>
            <RegionSelect />
          </>
        );
      }

      default: {
        break;
      }
    }
  };

  return (
    <UiSheet
      bottomOn="s"
      className={cn(
        "sdkui:z-999",
        !isMenuType && "sdkui:max-w-fit",
        !isMenuType && "sdkui:px-3 sdkui:py-3 sdkui:md:px-6",
        classNameByType(type)
      )}
      closeButton={closeButtonByType(type)}
      onOpenChange={handleOpenChange}
      open={isOpen}
      side={sideByType(type)}
    >
      {renderContent()}
    </UiSheet>
  );
};
